export enum LoanTenure {
    Six = 6,
    Twelve = 12,
    TwentyForur = 24,
    ThirtySix = 36
}
